<template>
    <div class="form-item">
        <div class="form-label">
            <label v-if="label != null">{{ label }}</label>
        </div>
        <div class="form-value" style="width: 446px">
            <el-radio-group :disabled="disabled" v-model="curValue" @change="syncModel">
                <el-radio v-for="dataItem in dataListInner" :label="dataItem[dataValue]">{{ dataItem[dataLabel] }}</el-radio>
            </el-radio-group>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    //有效的值类型
    let validValueTypes = ['Integer', 'String', 'Boolean'];

    function isValidValueType(valueType) {
        return validValueTypes.indexOf(valueType) != -1;
    }

    //转为指定的类型
    function castToTypedValue(srcValue, valueType) {
        let resultValue = srcValue;
        if(resultValue == null) {
            resultValue = null;
        }
        else {
            if(valueType == 'Integer') {
                resultValue = Utils.ParseInt(resultValue);
            }
            else if(valueType == 'Boolean') {
                resultValue = (resultValue + '') == 'true';
            }
            //String
        }
        return resultValue;
    }

    //
    export default {
        name: 'swb-query-radiogroup-field',
        //
        props: {
            valueType: {
                type: String,
                default: 'String'
            },
            label: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            dataList: {//{ label, value }
                type: Array,
                default: []
            },
            dataLabel: {
                type: String,
                default: 'label'
            },
            dataValue: {
                type: String,
                default: 'value'
            },
            iniValue: {
                default: null
            }
        },
        //
        data() {
            return {
                dataListInner: [],
                //
                curValue: null
            };
        },
        watch: {
            valueType(newVal, oldVal) {
                this.init();
            },
            dataList(newVal, oldVal) {
                this.init(this.curValue);
            },
            iniValue(newVal, oldVal) {
                this.init();
            }
        },
        //
        created() {
            this.init();
        },
        //
        methods: {
            init(oldValue) {
                if(!isValidValueType(this.valueType)) {
                    let message = '组件的值类型有误，可用的值类型为：' + validValueTypes.join(", ");
                    if(typeof Toast !== 'undefined') {
                        Toast.show(message, 3000, 'error');
                    }
                    else {
                        MsgBox.error(message);
                    }
                }
                //
                let valueType = this.valueType;
                let dataLabel = this.dataLabel;
                let dataValue = this.dataValue;
                //初始化
                let iniValue = null;
                if(typeof oldValue == 'undefined') {
                    iniValue = this.iniValue == null ? null : this.iniValue + '';
                }
                else {
                    iniValue = oldValue;
                }
                iniValue = castToTypedValue(iniValue, valueType);
                let iniValueFound = false;
                this.dataListInner = this.dataList.map(function (item) {
                    let itemInner = {};
                    itemInner[dataLabel] = item[dataLabel];
                    itemInner[dataValue] = item[dataValue] == null ? null : castToTypedValue(item[dataValue], valueType);
                    //检查初始值
                    if(itemInner[dataValue] == iniValue) {
                        iniValueFound = true;
                    }
                    return itemInner;
                });
                if(!iniValueFound) {
                    iniValue = null;
                }
                this.curValue = iniValue;

                this.syncModel();
            },
            syncModel() {
                let resultValue = this.curValue;
                //
                this.$emit('input', resultValue);
                this.$emit('change', resultValue);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/query/QueryRadioGroupField.vue